import { useContext } from 'react';

import { ProfileContext } from './';

export const useProfile = () => {
  return useContext(ProfileContext);
};
